import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import moment from "moment/moment";
import { WorkdayReportService } from "../../workday-report.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { locale as italian } from "../../../../i18n/it";
import { Router } from "@angular/router";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-my-archive",
  templateUrl: "./my-archive.component.html",
  styleUrls: ["./my-archive.component.scss"],
})
export class ArchiveUserReportsComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();

  public contentHeader: IContentHeader;

  public reportsList: any = [];

  public tableLimit: number = 10;

  public categories: any = [];

  public statuses_labels: any;

  public availableYears: any = [];

  public me: ICurrentUser;

  public reports: any = [];

  public startYear: number = 0;

  public startMonth: number = 0;

  public currentYear: number = 0;

  public currentMonth: number = 0;

  public monthInAYear: Array<number> = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  public selectRangeOfYears: any;

  public searchYear: any = moment().year();

  public filteredReport: any = [];

  constructor(
    public _workdayReportService: WorkdayReportService,
    public _utilService: UtilsService,
    public _userService: UserService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    public _router: Router,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.ARCHIVE_REPORTS,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.WORKDAY_USER_REPORT,
            isLink: false,
          },
          {
            name: italian.data.ARCHIVE_REPORTS,
            isLink: false,
          },
        ],
      },
    };

    const currentYear = moment().format("YYYY");
    for (let i = 2022; i <= Number(currentYear); i++) {
      this.availableYears.push(String(i));
    }
  }

  async ngOnInit() {
    this.currentMonth = moment().month() + 1;
    this.currentYear = moment().year();
    this.me = await this._authenticationService.getCurrentUser();
    if (this.me.role === "Collaboratore") {
      this._utilService.hideLoading();
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.startYear = moment(this.me.contract_start_date).year();
    this.startMonth = moment(this.me.contract_start_date).month();
    this.statuses_labels = await this._utilService.translate("STATUS");
    //Range di anni che partono dalla data inizio contratto(anno) fino all'anno corrente
    this.selectRangeOfYears = Array(moment().year() - this.startYear + 1)
      .fill(this.startYear)
      .map((year, index) => year + index);
    await this.loadReports();
  }

  reportsFilterList() {
    let items: any = this.reportsList.sort((a: any, b: any) => (b.month > a.month ? 1 : -1));
    items = items.filter((item: any) => item.year == this.searchYear);

    this.filteredReport = items;
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadReports() {
    this.reportsList = await this._workdayReportService.getMineReports();
    const approved: string = await this._utilService.translate("APPROVED");
    const saved: string = await this._utilService.translate("STATUS.SAVED");
    const notApproved: string = await this._utilService.translate("REJECTED");
    const pending: string = await this._utilService.translate("PENDING");

    const currentYear = moment().year();
    const currentMonth = moment().month();

    this.selectRangeOfYears.map((year: number) => {
      this.monthInAYear.map((month: number) => {
        if (currentYear === year && month > currentMonth + 1) {
          return false;
        } else if (currentYear !== year && this.startYear === year && month <= this.startMonth) {
          return false;
        } else if (currentYear === year && this.startYear === year && month <= this.startMonth) {
          return false;
        } else {
          const isPresentReport = this.reportsList.find((item: any) => item.month == month && item.year == year);
          if (!isPresentReport) {
            this.reportsList.push({ month: month, status: 4, year: year });
          }
        }
      });
    });
    this.reportsList.forEach((item: any) => {
      if (item.status === 2) {
        item.enabled_label = approved;
      } else if (item.status === 3) {
        item.enabled_label = notApproved;
      } else if (item.status === 0) {
        item.enabled_label = saved;
      } else if (item.status === 1) {
        item.enabled_label = pending;
      }
    });
    this.reportsFilterList();
    this._utilService.hideLoading();
  }

  formatLabel(month: number) {
    //Refactor della label filtro mese
    const date = moment();
    date.set("month", month - 1);
    return date.format("MMMM");
  }
}
